"use client";
import { j as e } from "./index.es44.js";
import { forwardRef as p } from "react";
import { composeClassNames as b } from "./index.es126.js";
import c from "./index.es128.js";
p(
  ({
    label: a,
    value: i,
    placeholder: o,
    onChange: r,
    state: l,
    message: s,
    isDisabled: m,
    ...t
  }, d) => /* @__PURE__ */ e.jsx("div", { children: /* @__PURE__ */ e.jsxs("label", { className: "bl-size-6 bl-display-block", children: [
    a,
    /* @__PURE__ */ e.jsx(
      "textarea",
      {
        ...t,
        ref: d,
        className: b(
          "bl-input",
          l && `bl-input--${l}`,
          "bl-m-t-1",
          "bl-p-y-3"
        ),
        onChange: r,
        value: i,
        disabled: m,
        placeholder: o
      }
    ),
    s && /* @__PURE__ */ e.jsx("div", { className: "bl-p-t-1", children: /* @__PURE__ */ e.jsx(c, { state: l, children: s }) })
  ] }) })
);
//# sourceMappingURL=index.es49.js.map
